<template>
  <div class="smHtit w1200">
    <h2>
      <a href="/">首页</a>>
      <a href="javascript:void(0)" v-for="(item,index) in navList">{{item.name}} <span v-if="index+1 != navList.length"> ></span></a>
    </h2>
  </div>
</template>

<script>
  export default {
    name: "tSmalltit",
    data() {
      return {
          navList:[{},{}],
      }
    },
    mounted() {
      this.initData();
    },
    methods: {
        initData: async function () {
            let url = window.location.pathname + window.location.search;
            let res = await this.$getJSON('nav/smallTitleNav',{url:url});
            if (res.code == 1) {
                this.navList = res.data.navList;
            }
        },

    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/layout/smalltit.vue